/* eslint-disable @typescript-eslint/camelcase */
import { BcsFlag } from "../unleash";

const BcsPermissionMedusa = {
  feature_shipment_c1: new BcsFlag.StringFlag("C1")
}

export const FlagsFeatureShipmentC1 = {
  ...BcsPermissionMedusa
};

export function initFlagsFeatureShipmentC1() {
  // register flags with namespaces for better grouping
  BcsFlag.register("flags", BcsPermissionMedusa);
}
